// src/components/AddTableDialog.js
import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Stack,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";

const AddTableDialog = ({
  open,
  onClose,
  newTable,
  setNewTable,
  onAdd,
  openAlert,
  setOpenAlert,
  errorMessage,
  setErrorMessage,
  loading,
}) => {
  const handleAdd = () => {
    if (!newTable.arrangement_name) {
      alert("テーブル名は必須です。"); // アラートを表示
      return; // 処理を中断
    }
    onAdd();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>新しいテーブルを追加</DialogTitle>
      <DialogContent>
        {/* <Box sx={{ width: '100%' }}>
                    <Collapse in={openAlert}>
                        <Alert
                            severity="error"
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpenAlert(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                        >
                            {errorMessage}
                        </Alert>
                    </Collapse>
                </Box> */}

        <TextField
          autoFocus
          margin="dense"
          label="テーブル名（必須）"
          fullWidth
          required
          value={newTable.arrangement_name}
          onChange={(e) =>
            setNewTable({ ...newTable, arrangement_name: e.target.value })
          }
        />
        <FormControl fullWidth margin="dense">
          <InputLabel>サイド</InputLabel>
          <Select
            value={newTable.side || ""}
            onChange={(e) => setNewTable({ ...newTable, side: e.target.value })}
            label="サイド"
          >
            <MenuItem value="groom">新郎側</MenuItem>
            <MenuItem value="bride">新婦側</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" sx={{ mr: 2, mb: 2 }} spacing={1}>
          <Button variant="contained" onClick={onClose} color="secondary">
            キャンセル
          </Button>
          <Box sx={{ position: "relative" }}>
            <Button
              variant="contained"
              onClick={handleAdd}
              disabled={loading}
              color="primary"
            >
              追加
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default AddTableDialog;
